<div class="complete-profile-page">
  <mat-card class="profile-card" appearance="outlined">
    <mat-card-content>
      <p class="step-label">Step 2 of 2</p>
      <h1 class="profile-card__heading">Almost there!</h1>
      <p class="profile-card__subheading">
        Tell us a bit about yourself to finish setting up your account.
      </p>

      @if (errorMessage()) {
        <div class="inline-error" role="alert" aria-live="assertive">
          {{ errorMessage() }}
        </div>
      }

      <form class="profile-form" [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
        <!-- Email (read-only, pre-filled) -->
        <div class="field-group">
          <label class="field-label" for="profileEmail">Email Address</label>
          <mat-form-field appearance="outline" class="full-width">
            <input
              matInput
              id="profileEmail"
              type="email"
              [value]="email()"
              readonly
              autocomplete="email"
            />
          </mat-form-field>
        </div>

        <!-- First name -->
        <div class="field-group">
          <label class="field-label" for="profileFirstName"
            >First Name <span class="required-mark" aria-hidden="true">*</span></label
          >
          <mat-form-field appearance="outline" class="full-width">
            <input
              matInput
              id="profileFirstName"
              type="text"
              formControlName="firstName"
              placeholder="Jane"
              autocomplete="given-name"
            />
            <mat-error>
              @if (firstNameControl.hasError('required')) {
                First name is required
              } @else if (firstNameControl.hasError('serverError')) {
                {{ firstNameControl.getError('serverError') }}
              }
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Last name -->
        <div class="field-group">
          <label class="field-label" for="profileLastName"
            >Last Name <span class="required-mark" aria-hidden="true">*</span></label
          >
          <mat-form-field appearance="outline" class="full-width">
            <input
              matInput
              id="profileLastName"
              type="text"
              formControlName="lastName"
              placeholder="Smith"
              autocomplete="family-name"
            />
            <mat-error>
              @if (lastNameControl.hasError('required')) {
                Last name is required
              } @else if (lastNameControl.hasError('serverError')) {
                {{ lastNameControl.getError('serverError') }}
              }
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Cell number (optional) -->
        <fieldset class="field-group field-group--fieldset">
          <legend class="field-label">Cell Number</legend>
          <app-phone-input formControlName="cellNumber" />
          @if (cellNumberControl.touched && cellNumberControl.hasError('serverError')) {
            <mat-error class="field-server-error">{{
              cellNumberControl.getError('serverError')
            }}</mat-error>
          }
        </fieldset>

        <!-- Job position (optional) -->
        <div class="field-group">
          <label class="field-label" for="profileJob">Job Title</label>
          <mat-form-field appearance="outline" class="full-width">
            <input
              matInput
              id="profileJob"
              type="text"
              formControlName="jobPosition"
              placeholder="e.g. Financial Manager"
              autocomplete="organization-title"
            />
            <mat-hint>Optional</mat-hint>
          </mat-form-field>
        </div>

        <button
          mat-flat-button
          type="submit"
          class="full-width"
          data-testid="complete-profile-submit"
          [disabled]="isLoading() || form.invalid"
        >
          @if (isLoading()) {
            <mat-spinner diameter="20" />
          } @else {
            Complete Registration
          }
        </button>
      </form>
    </mat-card-content>
  </mat-card>
</div>
